<template>
  <div class="batch-result">
    <h2>배치 결과 확인</h2>

    <!-- 검색 조건 : 시작일 / 종료일 / 검색 -->
    <div class="search-bar">
      <label>시작일</label>
      <input v-model="startDate" type="date" />
      <label>종료일</label>
      <input v-model="endDate" type="date" />
      <button class="primary" @click="search">검색</button>
    </div>

    <p v-if="message" class="error">{{ message }}</p>

    <div class="table-scroll">
      <table class="grid">
        <thead>
          <tr>
            <th>ID</th><th>배치명</th><th>기준일</th><th>성공/실패</th>
            <th>처리건수</th><th>시작시각</th><th>종료시각</th><th>메시지</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="r in rows" :key="r.id">
            <td>{{ r.id }}</td>
            <td>{{ r.batchName }}</td>
            <td>{{ fmtDate(r.calcDt) }}</td>
            <td><span class="badge" :class="statusClass(r.status)">{{ statusLabel(r.status) }}</span></td>
            <td class="num">{{ r.targetCnt != null ? r.targetCnt : '-' }}</td>
            <td>{{ fmtDt(r.startDt) }}</td>
            <td>{{ fmtDt(r.endDt) }}</td>
            <td class="msg">{{ r.message }}</td>
          </tr>
          <tr v-if="rows.length === 0"><td colspan="8" class="empty">배치 결과가 없습니다.</td></tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import api from '../api';

export default {
  name: 'BatchResult',
  data() {
    return { startDate: '', endDate: '', rows: [], message: '' };
  },
  created() { this.search(); },
  methods: {
    async search() {
      this.message = '';
      try {
        const res = await api.batchResults({ startDate: this.startDate, endDate: this.endDate });
        this.rows = res.data || [];
      } catch (e) { this.message = e.message; }
    },
    statusLabel(s) {
      if (s === 'SUCCESS') return '성공';
      if (s === 'FAIL') return '실패';
      if (s === 'RUNNING') return '실행중';
      return s || '-';
    },
    statusClass(s) {
      if (s === 'SUCCESS') return 'ok';
      if (s === 'FAIL') return 'fail';
      return 'run';
    },
    fmtDate(d) { return d ? String(d).substring(0, 10) : '-'; },
    fmtDt(d) { return d ? String(d).replace('T', ' ').substring(0, 19) : '-'; }
  }
};
</script>

<style scoped>
.batch-result { padding: 20px 24px; }
.batch-result h2 { margin: 0 0 16px; font-size: 20px; }
.search-bar { display: flex; align-items: center; gap: 8px; margin-bottom: 14px; flex-wrap: wrap; }
.search-bar label { font-size: 13px; color: #555; }
.search-bar input { padding: 7px 9px; border: 1px solid #d0d5dd; border-radius: 6px; }
.search-bar .primary { padding: 8px 16px; background: #2f6fed; color: #fff; border: none; border-radius: 6px; cursor: pointer; }
.table-scroll { overflow-x: auto; border: 1px solid #e5e8ef; border-radius: 8px; }
.grid { width: 100%; border-collapse: collapse; min-width: 720px; }
/* 구분선: 1가지 굵기·색상으로 통일 */
.grid th, .grid td { border-bottom: 1px solid #e5e8ef; padding: 8px 10px; font-size: 12.5px; text-align: left; }
.grid th { background: #f0f3fa; }
.grid td.num { text-align: right; }
.grid td.msg { color: #666; max-width: 320px; }
.badge { display: inline-block; padding: 2px 10px; border-radius: 10px; font-size: 11.5px; font-weight: 600; }
.badge.ok { background: #e5f5ea; color: #1a7f37; }
.badge.fail { background: #fdecec; color: #d93636; }
.badge.run { background: #eef1f7; color: #3a6; }
.empty { text-align: center; color: #999; padding: 16px; }
.error { color: #d93636; font-size: 13px; margin: 0 0 10px; }
</style>
